//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Utils from '../../../../utils';
import ConnectedFormField from './ConnectedFormField';

var FormFields = function FormFields(_ref) {
  var pageLayout = _ref.pageLayout;
  return React.createElement(Grid, null, pageLayout.rows.map(function (row, rowIdx) {
    return React.createElement(Grid, {
      item: true,
      container: true,
      direction: "row",
      key: row.id || rowIdx
    }, row.fields.map(function (field) {
      return React.createElement(Grid, {
        item: true,
        xs: field.size,
        key: field.id,
        className: "form-group"
      }, React.createElement(ConnectedFormField, {
        fieldId: field.id
      }));
    }));
  }));
};

export default React.memo(FormFields, function (prevProps, nextProps) {
  return Utils.deepEqual(prevProps, nextProps);
});